
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { NetworkTableThingyActions } from "../actions/table_actions";
import { scriptitem} from "../typing/table_typing";
import { myfetchThunk } from "../../../app/myfetch";
import {masteruri} from "../../../config";





interface ResponsePayloadScanamster{
        scriptlist:scriptitem[]
}

export const requestDataFromAPI =() => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/ScriptVault",
            {},
            "GET",
            (payload:ResponsePayloadScanamster) => {
                 dispatch(
                     NetworkTableThingyActions.resetData(
                          {
                            data : payload.scriptlist ?? [],
                          }
                      )
                  );
            },
            // On failure end the loading state as well. myfetch has already said
            // what went wrong; an empty table under an error message is honest,
            // a skeleton that spins for ever is not.
            () => {
                dispatch(NetworkTableThingyActions.resetData({ data: [] }));
            }
        ) as any)
    }
}

export const requestDataDeletionFromAPI =(uuid:string) => {
    return (
        dispatch:Dispatch<any>, 
        getState:() => RootState
    )=>{       
        dispatch(myfetchThunk(
            true,
            masteruri+"/ScriptVault/"+uuid,
            {},
            "DELETE",
            () => {},
            ()=>{}
        ) as any)
    }
}